import axios from 'axios'

export const RegisterUserApi = {
    getUsageTerms: () => axios.get('/usageTerms.txt'),
    register: (registerUserData) => axios.post('/web/users/register/', registerUserData)
}
